import { Images } from '../../../../@resources/img';
import { uuid } from '../../../../CodesThatsGottaGoSomewhereElse';
import { Token } from '../../tokens/Token';
import { TabularImportMappingStep } from '../steps/TabularImportMappingStep';
import { MappingFilter, MappingTarget, TabularImportStrategy } from '../TabularImportModel';
import { createMappingOnlyTabularImportStrategyFunction } from './Shared';

export const TokensTabularImportStrategy: TabularImportStrategy = {
    id: uuid(),
    label: 'Import as Tokens',
    image: Images.ImportTokens,
    steps: [
        TabularImportMappingStep({
            type: Token,
            typeLabel: 'Tokens',
            preview: [3, 4],
            targets: [
                MappingTarget('Value', 'value|value', MappingFilter.text(10)),
                MappingTarget('Color', 'background', MappingFilter.color),
            ]
        }),
    ],
    apply: createMappingOnlyTabularImportStrategyFunction(Token),
};
